import { jsonToGraphQLQuery } from 'json-to-graphql-query';
import axios from './api';

/**
 * Returns object from vehicle search endpoint
 *
 * @param {object} params The params to send into the function.
 * @return {object} The vehicle search object result.
 */

export default async (params) => {
  /**
   * @param {object} query The query to be converted into graphQ
   */
  const { query, clientToken, uuid, apiUrl } = params;
  const graphqlQuery = jsonToGraphQLQuery(query);
  const headers = {
    'Content-Type': 'application/json',
    Authorization: clientToken,
  };

  const response = await axios.post(`${apiUrl}/api/vehicle-search?uuid=${uuid}`, {
    query: graphqlQuery,
  }, { headers });

  return response.data;
};
